import type { TranslateDictionary } from './en.js';

export const Bg: TranslateDictionary = {
  'Start airplay': 'Стартирай AirPlay',
  'Stop airplay': 'Спри AirPlay',
  Audio: 'Аудио',
  Captions: 'Надписи',
  'Enable captions': 'Активиране на надписи',
  'Disable captions': 'Дезактивиране на надписи',
  'Start casting': 'Стартирай предаване',
  'Stop casting': 'Спри предаване',
  'Enter fullscreen mode': 'Влизане в режим на цял екран',
  'Exit fullscreen mode': 'Изход от режим на цял екран',
  Mute: 'Изключване на звука',
  Unmute: 'Включване на звука',
  'Enter picture in picture mode': 'Влизане в режим картина в картината',
  'Exit picture in picture mode': 'Изход от режим картина в картината',
  Play: 'Възпроизвеждане',
  Pause: 'Пауза',
  'Playback rate': 'Скорост на възпроизвеждане',
  'Playback rate {playbackRate}': 'Скорост на възпроизвеждане {playbackRate}',
  Quality: 'Качество',
  'Seek backward': 'Назад',
  'Seek forward': 'Напред',
  Settings: 'Настройки',
  Auto: 'Автоматично',
  'audio player': 'аудио плейър',
  'video player': 'видео плейър',
  volume: 'Сила на звука',
  seek: 'Търсене',
  'closed captions': 'Надписи',
  'current playback rate': 'текуща скорост на възпроизвеждане',
  'playback time': 'време на възпроизвеждане',
  'media loading': 'зареждане на медия',
  settings: 'Настройки',
  'audio tracks': 'аудио записи',
  quality: 'Качество',
  play: 'възпроизвеждане',
  pause: 'пауза',
  mute: 'изключване на звука',
  unmute: 'включване на звука',
  'chapter: {chapterName}': 'глава: {chapterName}',
  live: 'на живо',
  Off: 'Изключено',
  'start airplay': 'стартирай AirPlay',
  'stop airplay': 'спри AirPlay',
  'start casting': 'стартирай предаване',
  'stop casting': 'спри предаване',
  'enter fullscreen mode': 'влизане в режим на цял екран',
  'exit fullscreen mode': 'изход от режим на цял екран',
  'enter picture in picture mode': 'влизане в режим картина в картината',
  'exit picture in picture mode': 'изход от режим картина в картината',
  'seek to live': 'преминаване към живо',
  'playing live': 'възпроизвеждане на живо',
  'seek back {seekOffset} seconds': 'назад {seekOffset} секунди',
  'seek forward {seekOffset} seconds': 'напред {seekOffset} секунди',
  'Network Error': 'Мрежова грешка',
  'Decode Error': 'Грешка при декодиране',
  'Source Not Supported': 'Източникът не се поддържа',
  'Encryption Error': 'Грешка при криптиране',
  'A network error caused the media download to fail.':
    'Мрежова грешка доведе до неуспешно изтегляне на медията.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Грешка в медията доведе до прекратяване на възпроизвеждането. Медията може да е повредена или браузърът ви не поддържа този формат.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Възникна неподдържана грешка. Сървърът или мрежата се провалиха, или браузърът ви не поддържа този формат.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Медията е криптирана и няма ключове за декриптирането й.',
};
